import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/user/user.selector';
import { Container } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import './termination-button.styles.scss';
const TerminationButton = ({ _currentUser }) => {
  return (
    <Container
      className="shadow"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFBFAF',
        height: '50vh',
        borderRadius: '50px',
        justifyContent: 'center',
      }}
    >
      <div style={{ paddingBottom: '50px', fontWeight: 'bold' }}>
        Termination
      </div>
      <Link to="/automations/termination">
        <motion.button
          className="modal-button"
          type="button"
          whileHover={{ scale: 1.1, cursor: 'pointer' }}
          whileTap={{ scale: 0.95 }}
        >
          {`Deprovisioning Tool`}
        </motion.button>
      </Link>
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

export default connect(mapStateToProps)(TerminationButton);
